export enum ListItemPopoverType {
    MASTER = "master",
    CATALOG = "catalog",
}
